<template>
    <div class="row col-12">
        <div class="col-lg-12 form-group">
            <label for="referral-address-line-1"
                ><span v-if="addressName">{{ addressName }}</span> Address Line 1<span
                    class="text-danger"
                    v-if="isRequired"
                    >*</span
                ></label
            >
            <input
                :class="`form-control  ${
                    v$.address.AddressLine1.$error || getErrors('AddressLine1') ? 'border border-warning' : ''
                }`"
                maxlength="50"
                type="text"
                placeholder="Enter Address Line 1"
                v-model="address.AddressLine1"
                @blur="v$.address.AddressLine1.$touch"
                @change="(e) => handleAllInputChange('AddressLine1', e.target.value)"
            />
        </div>
        <div class="col-lg-12 form-group">
            <label for="referral-address-line-2"
                ><span v-if="addressName">{{ addressName }}</span> Address Line 2
            </label>
            <input
                class="form-control"
                maxlength="50"
                type="text"
                placeholder="Enter Address Line 2"
                v-model="address.AddressLine2"
            />
        </div>
        <div class="col-lg-6 form-group">
            <label for="referral-zip"
                ><span class="badge me-1" v-if="showCode">M0060</span> ZIP<span class="text-danger" v-if="isRequired"
                    >*</span
                >
            </label>
            <input
                :class="`form-control ${v$.address.Zip.$error || getErrors('Zip') ? 'border border-warning' : ''}`"
                maxlength="5"
                type="text"
                v-number-only
                placeholder="Enter Zip"
                v-model="address.Zip"
                @change="handleZipChange()"
                @blur="v$.address.Zip.$touch"
            />
        </div>
        <div class="col-lg-6 form-group" v-if="showZipFourCode">
            <label for="referral-zip">ZIP+4 </label>
            <input
                class="form-control"
                maxlength="4"
                type="text"
                v-number-only
                placeholder="Enter Zip"
                v-model="address.ZipCodeFour"
            />
        </div>
        <div class="col-lg-6 form-group">
            <label for="referral-county"> County<span class="text-danger" v-if="isCountyRequired">*</span> </label>
            <select
                :class="`form-select ${v$.address.County.$error || getErrors('County') ? 'border border-warning' : ''}`"
                v-model="address.County"
                @blur="v$.address.County.$touch"
                @change="(e) => handleAllInputChange('County', e.target.value)"
            >
                <option :value="null">Select County</option>
                <template v-if="countyData?.length">
                    <option :value="ctyData" :key="index" v-for="(ctyData, index) in countyData">
                        {{ ctyData }}
                    </option>
                </template>
                <option v-else disabled :value="null">List is empty</option>
            </select>
        </div>
        <div class="col-lg-6 form-group">
            <label for="referral-city"> City <span class="text-danger" v-if="isRequired">*</span></label>
            <input
                :class="`form-control ${v$.address.City.$error || getErrors('City') ? 'border border-warning' : ''}`"
                maxlength="50"
                type="text"
                placeholder="Enter City"
                v-model="address.City"
                @blur="v$.address.City.$touch"
                @change="(e) => handleAllInputChange('City', e.target.value)"
            />
        </div>
        <div :class="`form-group ${stateClass ? stateClass : 'col-lg-12'}`">
            <label for="referral-state"
                ><span class="badge me-1" v-if="showCode">M0050</span> State<span class="text-danger" v-if="isRequired"
                    >*</span
                >
            </label>
            <select
                :class="`form-select ${v$.address.State.$error || getErrors('State') ? 'border border-warning' : ''}`"
                v-model="address.State"
                @blur="v$.address.State.$touch"
                @change="(e) => handleAllInputChange('State', e.target.value)"
            >
                <option :value="null">Select State</option>
                <option
                    v-for="(addState, index) in referralOptions?.addressStateCode"
                    :value="addState.value"
                    :key="index"
                >
                    {{ addState.text }}
                </option>
            </select>
        </div>
    </div>
</template>

<script lang="ts" src="./ReferralAddressForm.ts"></script>
